module.exports = __webpack_public_path__ + "static/media/SE.6b02e90f.svg";